// extracted by mini-css-extract-plugin
export default {"button":"StyledPeriodButton_button__7pH9L","circleLeft":"StyledPeriodButton_circleLeft__oj8DN","circleRight":"StyledPeriodButton_circleRight__IPdRb"};